'use strict';

var GridToolbarConfigurationLegAssignmentDirective = function GridToolbarConfigurationLegAssignmentDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-configuration-leg-assignment.html'),
    controller: 'GridToolbarConfigurationLegAssignmentController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarConfigurationLegAssignmentDirective.$inject = [];
module.exports = GridToolbarConfigurationLegAssignmentDirective;